import { TextField, InputAdornment } from "@mui/material";
import { ChangeEvent } from "react";

interface MonthlyFeeInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export default function MonthlyFeeInput({ value, onChange, placeholder }: MonthlyFeeInputProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    if (inputValue.includes(".")) {
      const [whole, decimal] = inputValue.split(".");
      if (decimal.length > 2) {
        inputValue = `${whole}.${decimal.slice(0, 2)}`;
      }
    }
    onChange(inputValue);
  };

  return (
    <TextField
      type="number"
      name="monthlyFee"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      fullWidth
      margin="normal"
      label="Monthly Fee"
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      helperText="Enter monthly fee amount, Must include the dollars and cents (e.g. 120.00)"
    />
  );
}
